import { isEmpty } from 'lodash';
import React from 'react';
import { Button, Form, Offcanvas } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import Select from 'react-select';

const MoreSearchField = ({ showCanvas, closeCanvas, searchMoreField, selectRmk, onChangeRmk }) => {
  const { rmkOptions, activeRmk } = useSelector((state) => ({
    rmkOptions: state.utilsReducer.dropdownItems.rmkItems,
    activeRmk: state.rmkReducer.activeRmk,
  }));

  const handleClose = () => {
    closeCanvas();
  };

  const handleSearch = () => {
    searchMoreField();
    closeCanvas();
  };

  const handleResetField = () => {
    // Reset to active RMK
    if (activeRmk) {
      onChangeRmk(activeRmk);
    }
    // Reset federal projects
    localStorage.setItem('federalProjects', JSON.stringify({ label: 'Tidak', value: false }));
    searchMoreField();
  };

  const handleSelectFederalProject = (value) => {
    localStorage.setItem('federalProjects', JSON.stringify(value));
  };

  return (
    <Offcanvas show={showCanvas} onHide={handleClose} style={{ width: 310 }}>
      <Offcanvas.Body>
        <Offcanvas.Title className="mb-3">Carian Tambahan</Offcanvas.Title>
        <Form autoComplete="off" noValidate style={{ fontSize: 12 }}>
          <Form.Group className="mb-3">
            <Form.Label>RMK</Form.Label>
            <Select
              placeholder=""
              className="react-select-container"
              classNamePrefix="react-select"
              options={rmkOptions || []}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.number}
              value={selectRmk}
              onChange={(value) => onChangeRmk(value)}
              noOptionsMessage={() => 'Tiada pilihan'}
              isClearable={false}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Projek Persekutuan</Form.Label>
            <Select
              placeholder=""
              className="react-select-container"
              classNamePrefix="react-select"
              options={[
                {
                  label: 'Ya',
                  value: true,
                },
                {
                  label: 'Tidak',
                  value: false,
                },
              ]}
              value={
                JSON.parse(localStorage.getItem('federalProjects')) || {
                  label: 'Tidak',
                  value: false,
                }
              }
              onChange={(value) => handleSelectFederalProject(value)}
              noOptionsMessage={() => 'Tiada pilihan'}
            />
          </Form.Group>

          <div className="d-flex flex-column gap-3">
            <Button variant="primary" className="flex-fill" onClick={handleSearch}>
              Cari
            </Button>
            <Button variant="light" className="flex-fill" onClick={handleResetField}>
              Set Semula
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default MoreSearchField;
